/* global jQuery */

import GA4Tracking from './utils/ga4-tracking'
import { getCheckoutItems, getPaymentText } from './utils/_ga4-tracking-checkout'

export const handleAddPaymentInfoEvent = () => {
  jQuery('form.checkout').on( 'checkout_place_order_success', () => {
    const checkoutItems = getCheckoutItems()
    const paymentText = getPaymentText()

    if (checkoutItems !== null && paymentText !== undefined) {
      GA4Tracking.pushEvent('add_payment_info', checkoutItems, {payment_type: paymentText})
    }

    return true // return true to continue the submission
  })
}
